import { Box } from '@mui/material';
import { FC, useCallback } from 'react';
import { analytics, events } from 'services/analytics';
import { Recommendations } from '../../types';
import RecommendationResult from './RecommendationResult';

interface Props {
  recommendations: Recommendations;
}

const RecommendationResultItems: FC<Props> = ({ recommendations }) => {
  const aiRecommendationsTracking = useCallback(
    (index: number) => {
      const recommendation = recommendations[index];
      analytics.track(
        events.aiRecommendationClick(
          [recommendation.tags[0].name, recommendation.tags[1].name],
          index + 1
        )
      );
    },
    [recommendations]
  );
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(3, 70vw)',
          sm: 'repeat(3, 18rem)',
          md: 'repeat(3, 1fr)',
        },
        gridColumnGap: {
          xs: 10,
          sm: '2rem',
          md: '4rem',
        },
        overflowX: 'scroll',
        paddingBottom: 5,
      }}
    >
      {recommendations.map((recommendation, index) => (
        <Box key={recommendation.id}>
          <RecommendationResult
            recommendation={recommendation}
            onClick={() => aiRecommendationsTracking(index)}
          />
        </Box>
      ))}
    </Box>
  );
};
export default RecommendationResultItems;
